// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index-wrapper-Iugqk","title":"index-title-2S0F1","list":"index-list-1DVuV"};